var exports = {
  "K": "pendingBody__aM6az7",
  "j": "errorBanner___pjrdm",
};

module.exports = exports;
